module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    class: ['progress-bar', 'progress-bar-' + _vm.type, {
      active: _vm.animated,
      'progress-bar-striped': _vm.striped
    }],
    style: ({
      width: _vm.nowNum + '%'
    }),
    domProps: {
      "textContent": _vm._s(_vm.labelBool ? _vm.nowNum + '%' : null)
    }
  })
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68aa3375", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68aa3375!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Progressbar.vue
// module id = 246
// module chunks = 0